import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { GiPathDistance } from "react-icons/gi";
import { useApp } from '../../context/AppContext';
import { fadeIn } from '../../util/animation';
import Footer from '../../components/Footer';
import { Container, Content, Header, PenImage, StickFooter, Title} from './styles'

import TopImg from '../../assets/perseghian/top-3.png'
import BottomImg from '../../assets/perseghian/bottom-3.png'
import PenImg from '../../assets/perseghian/pen.png'
import LongDriveChart from '../../components/LongDriveChart';
import { MdOutlineFilterAltOff } from 'react-icons/md';
import { useLocation } from 'react-router-dom';



export default function BonusGames() {
	document.title = '2024 The Parseghian Classic - Long Drive'
	const {goToTop, clearAllSelections} = useApp()
  const day = new URLSearchParams(useLocation().search).get('day')
  const type = new URLSearchParams(useLocation().search).get('type')

  const [chartId, setChartId] = useState('AJFeJR')
  const [bonusSelect, setBonusSelect] = useState({day: day ||'spyglass-hill', type: type ||'longest-drive-men'})

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768 ? true : false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768 ? true : false);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const days = [
    { id: 'spyglass-hill', value: 'Spyglass Hill'},
    { id: 'pebble-beach', value: 'Pebble Beach'},
  ]

  const types = [
    { id: 'longest-drive-men', value: 'Longest drive men', day: 0},
    { id: 'longest-drive-women', value: 'Longest drive women', day: 0},
    { id: 'straightest-drive-men', value: 'Straightest drive men', day: 0},
    { id: 'straightest-drive-women', value: 'Straightest drive women', day: 0},
    { id: 'closest-to-hole-5', value: 'Closest to hole 5', day: 1},
    { id: 'closest-to-hole-7', value: 'Closest to hole 7', day: 1},
    { id: 'closest-to-hole-12', value: 'Closest to hole 12', day: 1},
    { id: 'closest-to-hole-17', value: 'Closest to hole 17', day: 1},
    { id: 'closest-to-hole-3', value: 'Closest to hole 3', day: 2},
    { id: 'closest-to-hole-5', value: 'Closest to hole 5', day: 2},
    { id: 'closest-to-hole-12', value: 'Closest to hole 12', day: 2},
    { id: 'closest-to-hole-15', value: 'Closest to hole 15', day: 2},
  ]

	useEffect(() => {
    goToTop()
  }, [goToTop])

  const chartsId = [
    { day: 'pebble-beach', type: 'longest-drive-men', chartId: 'AJFeJR' },
    { day: 'pebble-beach', type: 'longest-drive-women', chartId: 'fntsFJ' },
    { day: 'pebble-beach', type: 'straightest-drive-men', chartId: 'RjBHX' },
    { day: 'pebble-beach', type: 'straightest-drive-women', chartId: 'fxWj' },
    { day: 'pebble-beach', type: 'closest-to-hole-5', chartId: 'JjaZp' },
    { day: 'pebble-beach', type: 'closest-to-hole-7', chartId: 'cjxeND' },
    { day: 'pebble-beach', type: 'closest-to-hole-12', chartId: 'JdjKNZ' },
    { day: 'pebble-beach', type: 'closest-to-hole-17', chartId: 'fPsLpv' },

    { day: 'spyglass-hill', type: 'longest-drive-men', chartId: 'ae1fb0db-e15f-4ba6-80a8-eb3aeae84491' },
    { day: 'spyglass-hill', type: 'longest-drive-women', chartId: '82f33663-a8b5-4ceb-b630-942b1dcae3c2' },
    { day: 'spyglass-hill', type: 'straightest-drive-men', chartId: '85c6e12b-fb83-4678-bdea-d786e31641cc' },
    { day: 'spyglass-hill', type: 'straightest-drive-women', chartId: '7fa236b0-77ee-4dfa-aabf-eca5b71c3171' },
    { day: 'spyglass-hill', type: 'closest-to-hole-3', chartId: '7087606a-6cf3-479b-a41a-d9d585146557' },
    { day: 'spyglass-hill', type: 'closest-to-hole-5', chartId: '840a3085-6f5e-4c42-a39b-b5db76490b29' },
    { day: 'spyglass-hill', type: 'closest-to-hole-12', chartId: '46c87ee2-32ae-452a-9738-5e27cbb18f68' },
    { day: 'spyglass-hill', type: 'closest-to-hole-15', chartId: 'bf5dbb0f-7d0d-4d8e-8c94-e5744282f52c' },
  ]

	function renderChart(value: string, selectionType: 'day' | 'type') {
    let dayValue = selectionType === 'day' ? value : bonusSelect.day
    let typeValue = selectionType === 'type' ? value : bonusSelect.type

    if(selectionType === 'day') {
      typeValue = 'longest-drive-men'
    }
    
    setBonusSelect({
      day: dayValue,
      type: typeValue
    })
    
    const chart = chartsId.filter(item => item.day === dayValue && item.type === typeValue)?.[0]
    
    if(chartId !== chart.chartId) {
      setChartId(chart.chartId)
    }
  }

  return (
		<motion.div variants={fadeIn} initial="hidden" animate="show">
      <section className="">
        <section className="subs-bg-img bg-img-property pt-2">
            <div className="container pb-5">
              <section className="mt-3">
                <div className="container mb-3 text-center" >
                  <div className="row" >
                    <div className="card border-theme" style={{background: 'rgba(255, 255, 255, 0.85)', borderRadius: '15px' }}>
                      <div className="row card-header bg-sm-transparent bg-theme" style={{ borderRadius: '15px 15px 0 0' }}>
                        <div className='col-6 text-start'>
                          <div className="
                              fs-4 text-theme-yellow
                              d-flex justify-content-start align-items-center"
                            >
                              <GiPathDistance size={24} className="me-3 "/>
                              Bonuses
                            </div>
                        </div>
                        <div className="col-6 text-end">
                        <button onClick={() => clearAllSelections()} className="btn btn-sm text-theme btn-outline-light">
                          <MdOutlineFilterAltOff size={20}/>
                        </button>
                          {/* <button onClick={() => clearAllSelections()} className="btn btn-theme text-theme">Clear Selections</button> */}
                        </div>
                      </div>

                      <div className='row justify-content-center'>
                        <div className='row pt-3 pb-2'>
                          <div className='col-lg-3 col-sm-12 mb-2'>
                            <select 
                              className="form-select mb-lg-3 mb-2 mt-2" 
                              size={isMobile ? 1 : 2} 
                              aria-label="DefaultValue select example"
                              onChange={(e) => {
                                const selectedDay = e.target.value;
                                renderChart(selectedDay, 'day');
                              }}
                              value={bonusSelect.day}
                            >
                              {days.map(dayItem => (
                                <option className='px-1' key={dayItem.id} value={dayItem.id}>{dayItem.value} </option>
                              ))}
                            </select>
                            <select 
                              className="form-select"  
                              size={isMobile ? 1 : 8} 
                              aria-label="DefaultValue select example" 
                              onChange={(e) => {
                                const selectedType = e.target.value;
                                renderChart(selectedType, 'type');
                              }}
                              value={bonusSelect.type}
                            >
                              {types.filter(t => {
                                if(bonusSelect.day === 'pebble-beach') {
                                  return t.day === 0 || t.day === 1
                                } else {
                                  return t.day === 0 || t.day === 2
                                }
                              }).map(typeItem => (
                                <option className='px-1' key={typeItem.id} value={typeItem.id}>{typeItem.value}</option>
                              ))}
                            </select>
                          </div>
                          <div className='col-lg-9 col'>
                            <Container>
                              <Header>
                                <img src={TopImg} alt='long-drive'/>
                              </Header>
                              <Content>
                                <Title>
                                  <div className='title-description'>
                                    <p>{bonusSelect.type.toUpperCase().replaceAll('-', ' ')}</p>
                                  </div>
                                </Title>
  
                                <LongDriveChart id={chartId}/>
                                
                              </Content>
                              <StickFooter>
                                <img src={BottomImg} alt="Green Header" />
                              </StickFooter>
                              <PenImage>
                                <img src={PenImg} alt='pen'/>
                              </PenImage>
                            </Container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
          </div>
          <Footer />
        </section>
      </section>
		</motion.div>
  )
}